module.exports = __webpack_public_path__ + "img/logo_sub.89a44957.png";